// extracted by extract-css-chunks-webpack-plugin
module.exports = {"alertModal":"xch66","modalSection":"nI0M5"};